import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { decodeJSON } from "../utils/encoding";
import axios from "axios";
import useEffectAsync from "../hooks/useEffectAsync";

import config from '../config.json';

const LoginCallback = props => {
    const [ status, setStatus ] = useState({});

    const [ searchParams ] = useSearchParams();

    useEffectAsync(async () => {
        const [ code, state ] = [ searchParams.get("code"), searchParams.get("state") ];

        const { secret, redirect } = decodeJSON(localStorage.getItem("discord-oauth-state"));

        const receivedState = decodeJSON(state);

        if (secret !== receivedState?.secret) {
            setStatus({ error: "Secret mismatch, you may have been clickjacked!" });
            return;
        }

        await axios({
            url: `${config.backendUrl}/auth/login`,
            withCredentials: true,
            method: "post",
            data: { code, redirect_uri: config.redirectURI }
        });

        localStorage.removeItem("discord-oauth-state");

        setStatus({ success: true, redirect: redirect ?? "/" });
    }, []);

    if (status.error) return (<p>{status.error.toString()}</p>);

    if (status.success) window.location = status.redirect;

    return (<p>Logging in...</p>);
}

export default LoginCallback;
